export default "__VITE_ASSET__Cl6QNs7V__"